export const LABEL_EN = {
  // Status
  'tb_ft': 'Full time',
  'tb_1h': 'First half',
  'tb_home': 'Home',
  'tb_away': 'Away',
  'Menu Bill': 'Bill',
  'Example Quick bet':`Maximum data 50 set.
Each set must be on a different line.
Use * or . to separate.
End with = amount
Example
3*7*19*27=50
51*55*59=50
--------------
Example
3.7.19.27=50
51.55.59=50`,
  'MEMBER_STATUS_NORMAL':'Normal',
  'MEMBER_STATUS_NO_BET':'No Bet',
  'MEMBER_STATUS_LOCK':'Lock',
  'MEMBER_ACCEPT_STATUS_ONLINE':'Online',
  'MEMBER_ACCEPT_STATUS_SHOP':'Shop',

  'AGENT_STATUS_NORMAL':'Normal',
  'AGENT_STATUS_NO_BET':'No Bet',
  'AGENT_STATUS_LOCK':'Lock',
  'AGENT_BET_BILL_DEL_ON':'Del On',
  'AGENT_BET_BILL_DEL_OFF':'Del Off',

  'SUB_AGENT_STATUS_NORMAL':'Normal',
  'SUB_AGENT_STATUS_CLOSE':'Close',
  'TRANSFER_TYPE_DEPOSIT':'Deposit',
  'TRANSFER_TYPE_WITHDRAW':'Withdraw',
  'TRANSFER_TYPE_PAYOUT':'Payout',

  'BILL_STATUS_WIN': 'Win',
  'BILL_STATUS_PAYBACK': 'Payback',
  'BILL_STATUS_LOSE': 'Lose',
  'BILL_STATUS_CANCEL': 'Cancel',
  'BILL_STATUS_WAIT': 'Wait result',
  'PLAY_STATUS_WIN': 'Win',
  'PLAY_STATUS_WIN_HALF': 'Win half',
  'PLAY_STATUS_PAYBACK': 'Payback',
  'PLAY_STATUS_LOSE': 'Lose',
  'PLAY_STATUS_LOSE_HALF': 'Lose half',
  'PLAY_STATUS_CANCEL': 'Cancel',
  'PLAY_STATUS_WAIT': 'Wait result',
  'SCORE_STATUS_COMPLETED': 'Completed',
  'SCORE_STATUS_RUNNING': 'Running',
  'SCORE_STATUS_CANCEL': 'Cancel',
  'SCORE_STATUS_1H_CANCEL': 'First half cancel',
  'SCORE_STATUS_FT_CANCEL': 'Full time cancel',
  'BILL_ACCEPT_STATUS_CANCEL': 'Cancel',
  'BILL_ACCEPT_STATUS_NORMAL': 'Normal',
  'BILL_ACCEPT_STATUS_WAIT': 'Wait accept',
  'BILL_ACCEPT_STATUS_LIVE_CHECK': 'Checking',
  'BILL_ACCEPT_STATUS_LIVE_ACCEPT': 'Wait accept',
  'BILL_ACCEPT_STATUS_LIVE_REJECT': 'Reject',
  'Service_Support':'Support',
  'Price':'Price',

  // IP Check — English (also the fallback for la/mm/kh via fallbackLng)
  'IP Check':'IP Check',
  'Group IP':'Group IP',
  'Rapid Fire':'Rapid Fire',
  'Search IP or username':'Search IP / username',
  'Search username':'Search username',
  'Suspicious only':'Suspicious only',
  'Risk':'Risk',
  'Users':'Users',
  'Signals':'Signals',
  'Bills':'Bills',
  'Turnover':'Turnover',
  'Win/Loss':'Win / Loss',
  'Max Burst':'Max Burst',
  'accounts':'accounts',
  '/min':'/min',
  'No suspicious IP found':'No suspicious IP found',
  'No rapid-fire account found':'No rapid-fire account found',
  'Gap':'Gap',
  'Matches':'Matches (match id)',
  'Stake':'Stake',
  'Step':'Step',
  'Single':'Single',
  'Timeline hint':'Latest first · gap ≤5s (red) = abnormally fast',
  'Same side ×{{n}}':'Same side ×{{n}}',
  'Gap {{n}}s':'Gap {{n}}s',
  'Repeated stake':'Repeated stake',
  'Focus {{n}} matches':'Focus {{n}} matches',
  '{{n}} accts/IP':'{{n}} accts/IP',
  'Rapid ×{{n}} (<5s)':'Rapid ×{{n}} (<5s)',
  '{{n}} bills/min':'{{n}} bills/min',
  'Same match ×{{n}}':'Same match ×{{n}}',
  'Live only':'Live only',
}
